import styled from '@emotion/styled'
import {
  Content as RadixContent,
  Root as RadixRoot,
  Trigger as RadixTrigger,
} from '@radix-ui/react-collapsible'
import { ReactNode } from 'react'

import { theme } from '../constants'
import { StyleProps, createStyles } from '../utils'

type From = 'left' | 'right'

const Content = styled(RadixContent)<{ width: number }>`
  overflow: hidden;
  width: ${({ width }) => width}px;

  &[data-state='open'] {
    animation: slideIn 200ms ease-out;
  }

  &[data-state='closed'] {
    animation: slideOut 200ms ease-out;
  }

  @keyframes slideIn {
    from {
      width: 0;
    }
    to {
      width: ${({ width }) => width}px;
    }
  }

  @keyframes slideOut {
    from {
      width: ${({ width }) => width}px;
    }
    to {
      width: 0;
    }
  }
`

const Inner = styled.div<{ width: number; from: From; styles?: StyleProps }>(
  (props) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    [props.from === 'left' ? 'right' : 'left']: 0,
    width: props.width,
    overflow: 'auto',
    [props.from === 'left' ? 'borderRight' : 'borderLeft']:
      theme.border.style.thinLight,
    ...createStyles(props.styles),
  }),
)

type CollapsibleProps = {
  children: ReactNode
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
  styles?: StyleProps
  width: number
  from: From
}

const SidebarComponent = ({
  isOpen,
  setIsOpen,
  children,
  styles,
  width,
  from,
}: CollapsibleProps) => (
  <RadixRoot open={isOpen} onOpenChange={setIsOpen}>
    <Content width={width}>
      <Inner width={width} from={from} styles={styles}>
        {children}
      </Inner>
    </Content>
  </RadixRoot>
)

type TriggerProps = {
  children: ReactNode
}

const Trigger = ({ children }: TriggerProps) => {
  return <RadixTrigger asChild>{children}</RadixTrigger>
}

export const Sidebar = Object.assign(SidebarComponent, {
  Trigger,
})
